import operations from "./operations";
import actions from "./actions";

export default {
    actions,
    operations,
};
